export const PUT_AVATAR = "PUT_AVATAR";
export const PUT_AVATAR_SUCCESS = "PUT_AVATAR_SUCCESS";
export const PUT_AVATAR_ERROR = "PUT_AVATAR_ERROR";
export const PUT_AVATAR_CLEAR_DATA = "PUT_AVATAR_CLEAR_DATA";

